// extracted by mini-css-extract-plugin
export default {"root":"top-bar_root__OMD59","title":"top-bar_title__xwXKr","actionsBar":"top-bar_actionsBar__QOl5F","button":"top-bar_button__ikdn3","delete":"top-bar_delete__cKChy"};